const MESSENGER_TAB_ACTIVITY_MESSAGE_TYPE = 'textmagicMessengerTabActivity' as const

interface MessengerTabActivityMessage {
  type: typeof MESSENGER_TAB_ACTIVITY_MESSAGE_TYPE
  payload: boolean
}

export const subscribeOnMessengerTabActivity = (callback: (payload: boolean) => void) => {
  document.addEventListener('visibilitychange', () => {
    callback(document.visibilityState === 'visible')
  })
}

const isMessengerTabActivityMessage = (data: any): data is MessengerTabActivityMessage => {
  return data?.type === MESSENGER_TAB_ACTIVITY_MESSAGE_TYPE
}

export const sendMessengerTabActivityMessage = (iframe: HTMLIFrameElement, isActive: boolean) => {
  const message = {
    type: MESSENGER_TAB_ACTIVITY_MESSAGE_TYPE,
    payload: isActive,
  } satisfies MessengerTabActivityMessage

  iframe?.contentWindow?.postMessage(message, '*')
}

export const subscribeOnMessengerTabActivityMessages = (callback: (payload: boolean) => void) => {
  const listener = ({ data }: MessageEvent) => {
    if (isMessengerTabActivityMessage(data)) {
      callback(data.payload)
    }
  }
  window.addEventListener('message', listener)
  return listener
}
